import {TableBody as MUITableBody} from '@mui/material'
import React from 'react'

interface TableBodyProps extends React.ComponentProps<typeof MUITableBody> {}

export const TableBody: React.FC<TableBodyProps> = (props) => {
  return <MUITableBody {...props} />
}
